import React from 'react';
import Button from 'react-bootstrap/Button';
import { useEffect } from 'react';
import { CgCloseR } from "react-icons/cg";
import {
    myData
} from "../dbconnector/connector";

const AssignmentDetail = ({ rights, t, isDisabled, hotelcleanersarray, cleaningtypesarray, cleaningtaskarray, data, events, hotelid, date }) => {

    useEffect(() => {
        if (data.cleaningassignment.length > 0) {
            //console.log("eeeeeeeee", hotelid, "  ", date)//,sessionStorage.getItem('FocusOfTheDay_'+ hotelid +"_"+ date))
            document.getElementById("extradescription").value = sessionStorage.getItem('FocusOfTheDay_' + hotelid + "_" + date)
            events.handleOnchange({ target: { name: "extradescription", value: document.getElementById("extradescription").value } })
            //console.log("data =", data)
            //events.handleFocusOfftheday(sessionStorage.getItem('FocusOfTheDay_'+ hotelid +"_"+ date))
            //data.cleaningassignment.extradescription
        }
    }, [hotelid]);



    return (
        <>
            <div id="assignmentdetails" className='assignmentdiv'>
                <div className='formcaption' onMouseDown={(e) => events.startdrag("assignmentdetails", true, e)} onMouseUp={(e) => events.startdrag(null, false, e)}>{t(data.cleaningassignment.status !== 8? 'DetailsTaskTitle':'Removalreason')}<CgCloseR className='closer' onClick={events.handleCancel} /></div>
                <div className="AssignCleaningform" style={data.cleaningassignment.status === 8 ? { display: 'none' } : { display: 'grid' }}>
                    <label className='labelhotel'>
                        {t('Kamernr')}
                    </label>
                    <input id="roomnumber" value={data.cleaningassignment.roomnumber} name="roomnumber" className="doublegrid" type='text' onChange={events.handleOnchange} disabled>
                    </input>
                    <label className='labelhotel' style={data.cleaningassignment.cleaningtype_Id < -1 ? { display: "none" } : { display: "block" }}>
                        {t('Aankomst')}
                    </label>
                    <input id="Aankomst" checked={data.cleaningassignment.arrival} name="arrival" className="checkbox" type='checkbox' onChange={events.handleChangecheckbox} disabled={isDisabled} style={data.cleaningassignment.cleaningtype_Id < -1 ? { display: "none" } : { display: "block" }}>
                    </input> <label className='labelhotel' style={data.cleaningassignment.cleaningtype_Id < -1 ? { display: "none" } : { display: "block" }}>
                        {t('uitgechecked')}
                    </label>
                    <input id="uitgechecked" checked={data.cleaningassignment.checkedout} name="checkedout" className="checkbox" type='checkbox' onChange={events.handleChangecheckbox} disabled={isDisabled} style={data.cleaningassignment.cleaningtype_Id < -1 ? { display: "none" } : { display: "block" }}>
                    </input>
                    <label className='labelhotel'>
                        {t('Kamertype')}
                    </label>
                    <input id="roomtype" value={data.roomsettings.kamerTypeNaam} name="roomtype" className="doublegrid" type='text' onChange={events.handleOnchange} disabled>
                    </input>
                    <label className='labelhotel'>
                        {t('kuistype')}
                    </label>
                    <select id="cleaningtype_Id" value={data.cleaningassignment.cleaningtype_Id} name="cleaningtype_Id" className="doublegrid" type='text' onChange={(e) => events.showAssignedCleaningTasks(e, e.target.value)} disabled={isDisabled}>
                        <option value={-1}>{t('SelectCleaningType')}</option>
                        {cleaningtypesarray}
                    </select>
                    <label className='labelhotel' style={data.cleaningassignment.cleaningtype_Id < -1 ? { display: "none" } : { display: "block" }}>
                        {t('Standardtaken')}
                    </label>
                    <textarea type="textarea" id="cleaningtask" name="description" value={data.cleaningassignment.description} className="selectCleaningTasks doublegrid" disabled style={data.cleaningassignment.cleaningtype_Id < -1 ? { display: "none" } : { display: "block" }}>
                    </textarea>
                    <label className='labelhotel' >
                        {t('extrataken')}
                    </label>
                    <div id="extratasks" name="extratasks" type='text' disabled={isDisabled} className='checkboxDiv doublegrid'>
                        {cleaningtaskarray}
                    </div>
                    <label className='labelhotel' disabled={isDisabled}>
                        {t('Opmerking')}
                    </label>
                    <textarea id="extradescription" name="extradescription" className="doublegrid opmerkingen" type='text' value={data.cleaningassignment.extradescription} onChange={events.handleOnchange} disabled={isDisabled}>
                    </textarea>
                    {/* <label className='labelhotel'>
                        {t('meertijd')}
                    </label>
                    <input id="timeneeded" name="extratime" className="doublegrid" type='number' value={data.cleaningassignment.extratime} onChange={events.handleOnchange} disabled={isDisabled}> 
                    </input>*/}
                    <label className='labelhotel'>
                        {t('Medewerker')}:
                    </label>
                    <select id="assignee_Id" name="assignee_Id" className="doublegrid" type='text' value={data.cleaningassignment.assignee_Id} onChange={events.handleOnchange} disabled={isDisabled}>
                        <option value={-1} >{t('SelectEmployee')}</option>
                        {hotelcleanersarray}
                    </select>
                    <Button type="button" id="deleteButton" onClick={() => events.handlDeleteAssignment(data.cleaningassignment)} className="Deletebutton" >{t('Delete')}</Button>
                    <div id="saveDiv" className="two_Buttons doublegrid">
                        <Button type="button" id="EditButton" onClick={() => events.handlEditAssignment()} className="Savebutton" disabled={!isDisabled} style={isDisabled === false ? { display: "none" } : { display: "block" }}>{t('Edit')}</Button>
                        <Button type="button" id="updateButton" onClick={() => events.handlUpdateAssignment(data.cleaningassignment.id)} className="Savebutton" style={{ display: "none" }}>{t('Update')}</Button>
                        <Button type="button" id="saveButton" onClick={() => events.handlCreateAssignment()} className="Savebutton" disabled={isDisabled}>{t('Save')}</Button>
                        <Button type="button" id="cancelButton" className="Savebutton" onClick={events.handleCancel} >{t('Cancel')}</Button>
                    </div>
                </div>
                <div className="AssignCleaningform" style={data.cleaningassignment.status === 8 ? { display: 'grid' } : { display: 'none' }}>
                    <label className='labelhotel'>
                        {t('WhyDelete')}
                    </label>
                    <textarea id="deleteReason" className="selectCleaningTasks doublegrid" type='text' name="deleteReason" value={data.cleaningassignment.deleteReason} onChange={events.handleOnchange} disabled>
                    </textarea>
                    <label className='labelhotel' style={data.cleaningassignment.cleaningtype_Id < -1 ? { display: "none" } : { display: "block" }}>
                        {t('DeletedBy')}
                    </label>
                    <input id="Aankomst" name="deletedbyfullname" className="doublegrid" value={data.cleaningassignment.deletedbyfullname} type='text' onChange={events.handleOnchange} disabled={isDisabled}></input>
                    <div id="saveDiv" className="two_Buttons doublegrid">
                        <Button type="button" id="updateButton" onClick={() => events.ReSetAssignment(0)} className="Savebutton">{t('Reopen')}</Button>
                        <Button type="button" id="cancelButton" className="Savebutton" onClick={events.handleCancel} >{t('Cancel')}</Button>
                    </div>
                </div>
            </div>
        </>
    );
}


export default AssignmentDetail;
